export const appendUrlSearchParams = (url: URL, params: Record<string, string | number | undefined>): URL => {
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      url.searchParams.append(key, String(value))
    }
  })
  return url
}
